import Phaser from 'phaser';

export function fadeIn(scene: Phaser.Scene, duration = 350): void {
  scene.cameras.main.fadeIn(duration, 0, 0, 0);
}

export function fadeOut(scene: Phaser.Scene, duration = 250): Promise<void> {
  return new Promise(resolve => {
    scene.cameras.main.fadeOut(duration, 0, 0, 0);
    scene.cameras.main.once('camerafadeoutcomplete', resolve);
  });
}

export function shakeLight(scene: Phaser.Scene): void {
  scene.cameras.main.shake(60, 0.002);
}

export function shakeHeavy(scene: Phaser.Scene): void {
  scene.cameras.main.shake(200, 0.008);
}
